import * as angular from 'angular';
import * as _ from 'lodash';
import ngRedux from 'ng-redux';

import { groupSelected, groupSaved, tagSaved, groupTreeChanged, identifierSaved, groupCanSelect } from '../../common/events';
import { IGroupService } from '../../services/data';
import { ImportedTagDefinition, Group, ComponentDefinition } from '../../models';
import { Store } from '../../stateManagement/Store';

class LightGroupTreeController implements angular.IComponentController {

    dropCallback: (d: any) => void;
    groups: any[];
    isLoading: boolean;
    isSelectionPrevented?: boolean;
    selectedGroup: any;

    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$ngRedux',
        'groupService'
    ];
    private _unsubscribe: () => void;

    constructor(private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _$ngRedux: ngRedux.INgRedux,
        private _groupService: IGroupService) {
    }

    $onInit() {
        const groupGuid = this._$stateParams['groupGuid'];
        this.refresh(groupGuid);
        this._$scope.$on(groupSaved, (event, data) => {
            const group = data.savedGroup.group; //a dto is sent back
            this.updateSelectedGroup(group);
        });

        this._$scope.$on(tagSaved, (event, data) => {
            this.refresh(this.selectedGroup ? this.selectedGroup.guid : null);
        });

        this._$scope.$on(groupTreeChanged, () => {
            this.refresh(this.selectedGroup ? this.selectedGroup.guid : null);
        });

        this._$scope.$on(identifierSaved, (event, data, groupId) => {
            if (this.selectedGroup && this.selectedGroup.guid !== groupId) {
                this.refresh(groupId, false);
            } else {
                this.refresh(null, false);
            }
        });

        this._unsubscribe = this._$ngRedux.connect((state: Store) => {
            return {

            };
        }, (dispatch: ngRedux.Dispatch) => {
            return {
                groupSelected: (group: Group) => dispatch({ type: 'GROUP_SELECTED', payload: group })
            };
        })(this);
    }
    groupSelected: (group: Group) => void;
    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    private updateSelectedGroup(group) {
        const found = _.find(this.groups, g => g.guid === group.guid);
        if (found) {
            found.identifierCollection = group.identifierCollection;
            this.selectedGroup = found;
            this.groupSelected(this.selectedGroup);
            this._$rootScope.$broadcast(groupSelected, found, true);
        }
    }

    select(group, $event: angular.IAngularEvent) {
        // Allow to cancel selection of group (by example because form is dirty)
        const ev = this._$rootScope.$broadcast(groupCanSelect, this.selectedGroup, true);
        if (!ev.defaultPrevented && !this.isSelectionPrevented) {
            if (group && group.name !== 'root') {
                this.selectedGroup = group;
            } else {
                this.selectedGroup = null;
            }

            this.groupSelected(this.selectedGroup);
            this._$rootScope.$broadcast(groupSelected, this.selectedGroup, true);
        }

        $event.preventDefault();
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    createIdentifier(group: any, dragObject: ImportedTagDefinition) {
        if (this.dropCallback) {
            this.dropCallback({ group: group, dragObject: dragObject });
        }
    }

    private refresh(groupGuid?: string, doReset?: boolean) {
        this.isLoading = true;
        this._groupService.getAllAsTree()
            .then(data => {
                this.groups = data;
                if (groupGuid) {
                    this.selectedGroup = _.find(this.groups, g => g.guid === groupGuid);
                    this._$rootScope.$broadcast(groupSelected, this.selectedGroup, (doReset !== undefined) ? doReset : true);
                }
            })
            .finally(() => this.isLoading = false);
    }
}

export const wtLightGroupTree: ComponentDefinition = {
    componentId: 'wtLightGroupTree',
    controller: LightGroupTreeController,
    template: require('./lightGroupTree.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedGroup: '=?',
        isEditMode: '=',
        dropCallback: '&?',
        isLoading: '=?',
        depthGroup: '@?',
        isSelectionPrevented: '<?'
    }
};
